import { Box, Button, Typography } from '@mui/material'
import AddFile from '../Organization/AddFile'
import { useState } from 'react'

interface StartNewFileProps {}

const StartNewFileComponent: React.FC<StartNewFileProps> = ({}) => {
  const [isAddFileDialogOpen, setIsAddFileDialogOpen] = useState(false)

  return (
    <>
      <Button
        disableRipple
        onClick={() => setIsAddFileDialogOpen(true)}
        sx={{
          background: '#E5F0FF',
          borderRadius: '0.4rem',
          width: '100%',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          gap: '1rem',
          p: '0.75rem',
          maxHeight: '14.4rem',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            placeContent: 'center',
            width: '100%',
            mt: '3rem',
            '& > .MuiBox-root': {
              gridArea: '1 / 1 / 1 / 1',
              position: 'relative',
              overflow: 'hidden',
            },
          }}
        >
          <Box
            component='img'
            src={`/images/fileExample1.png`}
            alt='File Example'
            sx={{
              left: '-3.7rem',
              width: '8rem',
            }}
          ></Box>
          <Box
            sx={{
              top: '-2rem',
              width: '8rem',
              height: '5rem',
              borderRadius: '0.4rem',
              boxShadow: '0px 1px 5px 0px #00000040',
              background: '#FFFFFF',
              color: '#1705E5',
              fontSize: '4rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              fontWeight: 1,
              pb: '3px',
            }}
          >
            +
          </Box>
          <Box
            sx={{
              left: '3.7rem',
              top: '1rem',
              width: '8rem',
            }}
            component='img'
            src={`/images/fileExample2.png`}
            alt='File Example'
          ></Box>
        </Box>
        <Box>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.82rem',
              color: '#04002E',
              textTransform: 'none',
            }}
          >
            Start a New File
          </Typography>
          <Typography
            component='div'
            sx={{
              fontSize: '0.7rem',

              color: '#797979',
              textTransform: 'none',
            }}
          >
            Start from scratch or from 2D or 3D files
          </Typography>
        </Box>
      </Button>
      <AddFile
        isOpen={isAddFileDialogOpen}
        handleClose={() => setIsAddFileDialogOpen(false)}
      />
    </>
  )
}

export default StartNewFileComponent
